import React from 'react'
import './publications-hero.css'

export default function PublicationsHero() {
  return (
    <section className='publications-hero'>
      <div className='publications-hero__content'>
        <h1 className='publications-hero__title'>Publicaciones</h1>
        <p className='publications-hero__subtitle'>
          Aquí recogemos investigaciones propias, artículos, entrevistas y voces colaboradoras que abren reflexión y debate en torno a la menarquia, la menstruación, el ciclo, el climaterio y la salud sexual y (no)reproductiva.
        </p>
      </div>
    </section>
  )
}
